import * as angular from 'angular';

"use strict";
angular.module('MomentModule', []);

export default 'MomentModule';
